import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import logo from '../../assets/logo-full.png';
import './Welcome.css';

const Welcome = () => {
  const navigate = useNavigate();
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isAnimating, setIsAnimating] = useState(false);

  const slides = [
    {
      icon: '🤖',
      title: 'AI-Powered Trading',
      description: 'Experience the future of investment with our advanced AI algorithms that analyze markets 24/7 for optimal returns.'
    },
    {
      icon: '🏢',
      title: 'Dubai Based',
      description: 'Headquartered in Dubai, UAE - the global hub for innovation and financial excellence in the Middle East.'
    },
    {
      icon: '💎',
      title: 'Binary MLM System',
      description: 'Build your network with our powerful binary structure. Earn from your team\'s success with unlimited depth.'
    },
    {
      icon: '📈',
      title: 'Daily ROI Returns',
      description: 'Earn up to 3% daily ROI based on your direct business. Watch your investment grow every single day.'
    },
    {
      icon: '🔒',
      title: 'Secure & Transparent',
      description: 'Built on BSC blockchain with smart contracts. Your funds are always secure and transactions are transparent.'
    }
  ];

  const features = [
    { icon: '⚡', text: 'Instant Withdrawals' },
    { icon: '🌍', text: 'Global Community' },
    { icon: '💰', text: '300% Cap Returns' },
    { icon: '🔐', text: 'Smart Contract Based' }
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setIsAnimating(true);
      setTimeout(() => {
        setCurrentSlide((prev) => (prev + 1) % slides.length);
        setIsAnimating(false);
      }, 300);
    }, 4000);

    return () => clearInterval(interval);
  }, [slides.length]);

  const handleGetStarted = () => {
    localStorage.setItem('gainforce_welcomed', 'true');
    navigate('/home');
  };

  return (
    <div className="welcome-page">
      <div className="welcome-bg-effects">
        <div className="welcome-glow-1"></div>
        <div className="welcome-glow-2"></div>
        <div className="welcome-grid"></div>
      </div>

      <div className="welcome-content">
        <div className="welcome-header">
          <div className="welcome-logo-container">
            <img src={logo} alt="Gainforce" className="welcome-logo" />
          </div>
          <div className="welcome-badge">
            <span className="badge-icon">🇦🇪</span>
            <span className="badge-text">Dubai, UAE</span>
          </div>
        </div>

        <div className="welcome-tagline">
          <h1>Next Generation</h1>
          <h2>AI Trading Platform</h2>
          <p className="welcome-subtitle">
            Empowering investors worldwide with cutting-edge artificial intelligence 
            and blockchain technology
          </p>
        </div>

        <button className="welcome-cta" onClick={handleGetStarted}>
          <span className="cta-text">Get Started</span>
          <span className="cta-arrow">→</span>
        </button>

        <div className="welcome-slider">
          <div className={`slide ${isAnimating ? 'slide-exit' : 'slide-enter'}`}>
            <span className="slide-icon">{slides[currentSlide].icon}</span>
            <h3 className="slide-title">{slides[currentSlide].title}</h3>
            <p className="slide-description">{slides[currentSlide].description}</p>
          </div>
          <div className="slide-dots">
            {slides.map((_, idx) => (
              <button
                key={idx}
                className={`slide-dot ${idx === currentSlide ? 'active' : ''}`}
                onClick={() => setCurrentSlide(idx)}
              />
            ))}
          </div>
        </div>

        <div className="welcome-features">
          {features.map((feature, idx) => (
            <div key={idx} className="welcome-feature">
              <span className="feature-icon">{feature.icon}</span>
              <span className="feature-text">{feature.text}</span>
            </div>
          ))}
        </div>

        <div className="welcome-stats">
          <div className="stat-item">
            <span className="stat-value">$10M+</span>
            <span className="stat-label">Total Volume</span>
          </div>
          <div className="stat-divider"></div>
          <div className="stat-item">
            <span className="stat-value">50K+</span>
            <span className="stat-label">Active Users</span>
          </div>
          <div className="stat-divider"></div>
          <div className="stat-item">
            <span className="stat-value">99.9%</span>
            <span className="stat-label">Uptime</span>
          </div>
        </div>

        <div className="welcome-footer">
          <p className="footer-text">Powered by Binance Smart Chain</p>
          <div className="footer-icons">
            <span>🔗</span>
            <span>BSC</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Welcome;
